import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CollectionApiResponse} from '../../../lib/util/api-response';
import {SpesenItem} from './spesen.model';
import { HttpClient } from '@angular/common/http';
import {SpesenartItem} from './spesenart.model';

type Spesen = CollectionApiResponse<SpesenItem>;
type SpesenArten = CollectionApiResponse<SpesenartItem>;

@Injectable({ providedIn: 'root'})

export class SpesenartService {

  constructor(private http: HttpClient) {}

  public getAllSpesenarten(): Observable<SpesenArten> {

    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/spesenarten/getAllSpesenarten.php?${sessionStorage.getItem('session')}&isActive=${sessionStorage.getItem('spesenartIsAktiv')}`) as Observable<
      SpesenArten
      >;
  }

  public getInactiveSpesenarten(): Observable<SpesenArten> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/spesenarten/getInactiveSpesenarten.php?${sessionStorage.getItem('session')}`) as Observable<
      SpesenArten
      >;
  }
  public addSpesenart(spesenart: SpesenartItem): Observable<SpesenartItem> {
    // tslint:disable-next-line:max-line-length
    return this.http.post (window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/spesenarten/addSpesenart.php?${sessionStorage.getItem('session')}`, spesenart) as Observable<
      SpesenartItem
      >;
  }

  public deleteSpesenart(spesenart: SpesenartItem): Observable<SpesenartItem> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/spesenarten/deleteSpesenart.php?${sessionStorage.getItem('session')}&spesenartId=${spesenart.id}`) as Observable<
      SpesenartItem
      >;
  }

  public deactivateSpesenart(spesenart: SpesenartItem): Observable<SpesenartItem> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/spesenarten/deactivateSpesenart.php?${sessionStorage.getItem('session')}&spesenartId=${spesenart.id}`) as Observable<
      SpesenartItem
      >;
  }


  public activateSpesenart(spesenart: SpesenartItem): Observable<SpesenartItem> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/spesenarten/activateSpesenart.php?${sessionStorage.getItem('session')}&spesenartId=${spesenart.id}`) as Observable<
      SpesenartItem
      >;
  }

  public editSpesenart(spesenart: SpesenartItem): Observable<SpesenartItem> {
    // tslint:disable-next-line:max-line-length
    return this.http.put(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/spesenarten/editSpesenart.php?${sessionStorage.getItem('session')}`, spesenart) as Observable<
      SpesenartItem
      >;
  }
}
